
export interface AddressChangeParams {
  isInitChange?: boolean; // true编辑表单回显时，false手动变更地址
  lng: any;
  lat: any;
  cityName: any;
  poiId: any;
  name: any;
  identification: any;
  isCluster?: boolean; // 是否展示选址地图商圈（展示为CircleAddress时提交的textValue中isCluster为true）
};

/**
 * @Description 门店状态定义
 */
export enum ShopStatus {
  Signed = 100, // 已签约
  DeliverApproving = 200, // 交房审批中
  Delivered = 300, // 已交房
  OpenApproving = 400, // 开业审批中
  Openning = 500, // 开业中
  CloseApproving = 600, // 闭店审批中
  CLosed = 700, // 已闭店
}

export enum CircleBusinessZoom {
  MinZomm = 14,
  MaxZomm = 16
}
export interface LatLongItem{
  lng: number;
  lat: number
}


export interface CityIds{
  provinceId:number;
  cityId:number;
  districtId:number;
}

export interface ShopBasic {
  id:number;
  type:number; // 类型 1:机会点 2:门店
  name:string;
  icon:string;
  color:string;
  address:string;
  status:number; // 机会点状态值
  statusName:string;
  openDate:string;
  closeDate:string;
  closeReason:string;
  chancePointId:number;
  logo?:string;
}

export type ShopItem = ShopBasic&CityIds&LatLongItem;

export interface ModelClusterInfo {
  inCluster: boolean;
  id: number;
  centerName: string;
  centerLng: number;
  centerLat: number;
  radius: number;
  polygon: Array<LatLongItem> | null;
}

const demoClusterA: ModelClusterInfo = {
  inCluster: true,
  'id': 1051663,
  'centerName': '杭州水晶城购物中心',
  'centerLng': 120.151756,
  'centerLat': 30.304406,
  'radius': 0,
  'polygon': [
    {
      'lng': 120.15053987503052,
      'lat': 30.30467435880352
    },
    {
      'lng': 120.15233159065247,
      'lat': 30.305526531565967
    },
    {
      'lng': 120.15243887901306,
      'lat': 30.303359034129333
    },
    {
      'lng': 120.15222430229187,
      'lat': 30.303136723990303
    }
  ]
};

const demoClusterB: ModelClusterInfo = {
  inCluster: false,
  'id': 509973,
  'centerName': '学院路-1',
  // 'centerLng': 120.1279405666667,
  // 'centerLat': 30.292729700000002,
  'centerLng': 120.153662,
  'centerLat': 30.304024,
  'radius': 121,
  'polygon': null,
};

export const demoClusterList: ModelClusterInfo[] = [
  demoClusterA,
  demoClusterB
];

export const demoShopList: any[] = [
  {
    'id': 31,
    'type': 2,
    'name': '水晶城一楼连廊',
    'icon': 'ic_mendian',
    'color': '#006AFF',
    'address': '浙江省杭州市拱墅区大关街道凯迪仕智能锁(水晶城购物中心店)水晶城购物中心',
    'provinceId': 11,
    'cityId': 87,
    'districtId': 814,
    'lng': '120.151599',
    'lat': '30.304618',
    'status': 100,
    'statusName': '已签约',
    'openDate': null,
    'closeDate': null,
    'closeReason': null,
    'chancePointId': 10106
  },
  {
    'id': 32,
    'type': 2,
    'name': '水晶城一楼连廊1',
    'icon': 'ic_mendian',
    'color': '#B61FE0',
    'address': '浙江省杭州市拱墅区大关街道凯迪仕智能锁(水晶城购物中心店)水晶城购物中心',
    'provinceId': 11,
    'cityId': 87,
    'districtId': 814,
    'lng': '120.154175',
    'lat': '30.303764',
    'status': 100,
    'statusName': '已签约',
    'openDate': null,
    'closeDate': null,
    'closeReason': null,
    'chancePointId': 10106
  },
  {
    'id': 33,
    'type': 2,
    'name': '水晶城一楼连廊2',
    'icon': 'ic_mendian',
    'color': '#FF0000',
    'address': '浙江省杭州市拱墅区大关街道凯迪仕智能锁(水晶城购物中心店)水晶城购物中心',
    'provinceId': 11,
    'cityId': 87,
    'districtId': 814,
    'lng': '120.152893',
    'lat': '30.303948',
    'status': 100,
    'statusName': '已签约',
    'openDate': null,
    'closeDate': null,
    'closeReason': null,
    'chancePointId': 10106
  }
];

export const FAMOUS_BRAND = 'FAMOUS_BRAND'; // 知名品牌code
